import React, {useState, useEffect} from 'react'
import TokenCard from '../TokenCard'
import { useSelector, useDispatch } from 'react-redux';
import { getOp20Balance } from '../../util/op20-api';
import { v4 as uuidv4 } from 'uuid';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Input,
  Spinner
} from "@material-tailwind/react";
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import Dust20Card from '../TokenSaleCard/Dust20Card';
import { useTranslation } from 'react-i18next';
import { getDust20BalanceTicker } from '../../util/dust20-api';
import { launchpadTokenRandom } from '../../util/new-api';
import { formatNumberWithCommas } from '../../util/format-data';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Op20(props) {
  const { keyAddress } = props;

  const currentPath = useLocation().pathname;
  const navigate = useNavigate();

  const wallet = useSelector(state => state.wallet);
  const { t, i18n } = useTranslation();
  const [data, setData] =  useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(12);
  const [page, setPage] = useState(1);
  const [showDetail, setShowDetail] = useState(false);
  const [tick, setTick] = useState(false);
  const [sum, setSum] = useState(0);
  const [ownDustzero, setOwnDustZero] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchAllDust20();
      }
      catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, [keyAddress, page])

  useEffect(() => {
    //handleRoyalty();
  }, [wallet.nostrOrdinalsAddress])

  const handleRoyalty = async () => {
    let results = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 1) // dustzero
    if (results.data.length == 0) {
      setOwnDustZero(false);
    }
    else setOwnDustZero(true);

  }

  const fetchAllDust20 = async() => {
    setLoading(true);
    if (keyAddress == "") {
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }
    try{
      let data = await getOp20Balance(keyAddress, page, limit);
      setTotal(Math.ceil(data.total / limit));
      setData(data.data);
    }
    catch(e) {
      setLoading(false);
    }
    setLoading(false);
  }

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const handleClickShowDetail = (tick, total) => {
    setShowDetail(true);
    setTick(tick);
    setSum(total);
  }

  return (
    <div className="flex flex-col w-full">
      {
        showDetail ? 
        <Dust20Detail keyAddress = {keyAddress} tick = {tick} handle = {() => {setShowDetail(false)}} sum = {sum} isZero = {ownDustzero} /> 
        : 
        <>
          {
            loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
          }
          <div className="grid 2xl:grid-cols-6 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 w-full mt-5">
            {
              data.length > 0 ? 
                data.map((data) => {
                  return <div key={uuidv4()} className="bg-background2 border-solid border-[1px] border-gray-600 rounded-md md:p-4 p-3 flex flex-col gap-2 justify-center items-center">
                  <div className="text-primary text-xl font-bold">{data.ticker}</div>
                  <div className="text-white text-xl font-bold">{formatNumberWithCommas(data.amount)}</div>
                  {
                    currentPath.includes('profile') ?
                    <div className="flex flex-row gap-2">
                      <div className="bg-primary text-white text-md font-bold px-4 py-[6px] rounded-md mt-2 cursor-pointer" onClick={() => {navigate(`/inscribe/op_return/transfer/${data.ticker}`)}}>{t('Transfer')}</div>
                      <div className="bg-primary text-white text-md font-bold px-6 py-[6px] rounded-md mt-2 cursor-pointer" onClick={() => {navigate(`/trade/op_return/${data.ticker}`)}}>{t('Trade')}</div>
                    </div>
                    :
                    <></>
                  }
                </div>
                }) : <>No OP-20 Tokens.</>
            }
          </div>
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={next}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
            :
            <></>
          }
        </>
      }
    </div>
  )
}
